import { render } from "./Courses.vue?vue&type=template&id=97541184&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=97541184&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-97541184"

export default script